
import { defineComponent, ref, inject, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useToast } from "vue-toastification";

import { AxiosError } from "axios";

// components
import EmailTemplateList from "@/components/molecules/EmailTemplateList.molecules.vue";

// services
import emailService from "@/services/email.service";

// interfaces
import { IEmail } from "@/interfaces/email";
import { email } from "@vuelidate/validators";

export default defineComponent({
  components: {
    EmailTemplateList,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const toast = useToast();

    const setPageTitle = inject("setPageTitle") as CallableFunction;
    onMounted(() => setPageTitle("Pilih Template Email"));

    const templates = ref<IEmail[]>([]);
    onMounted(async () => {
      const { data } = await emailService.getEmailTemplates();
      templates.value = data;

      const defaultTemplate = data.find((d: IEmail) => d.is_default === 1);
      if (defaultTemplate) setSelectedTemplate(defaultTemplate.id);
    });

    const goBack = () => {
      router.go(-1);
    };

    // select assessment
    const selectedTemplate = ref<string | undefined>(undefined);
    const setSelectedTemplate = (val: string) => {
      selectedTemplate.value = val;
    };

    // pay handler
    const handleNext = async () => {
      try {
        const reqQueries = route.query;
        const projectId = Number(route.params.projectId);

        router.push({
          path: `/admin/project/${projectId}/confirm-email-template`,
          query: { ...reqQueries, email_template_id: selectedTemplate.value },
        });
      } catch (e) {
        let errMsg = (e as AxiosError).response?.data?.error || "Ada kesalahan";
        toast.error(errMsg);
      }
    };

    const canSubmit = computed(() => selectedTemplate.value);

    return {
      templates,
      setSelectedTemplate,
      selectedTemplate,
      handleNext,
      goBack,
      canSubmit,
    };
  },
});
